import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { TutorialList } from './TutorialList'
import { TutorialsProps } from './types'

export const Tutorials: FC<TutorialsProps> = ({ seo, header, footer, content }) => {
  const { breadcrumb, title, subtitle, description, featuredImg, tutorials } = content

  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured
        breadcrumb={breadcrumb}
        title={title}
        subtitle={subtitle}
        description={description}
        featuredImg={featuredImg}
      />
      <TutorialList tutorials={tutorials} />
    </Page>
  )
}
